import { render, staticRenderFns } from "./BackgroundRemoverDetail.vue?vue&type=template&id=020fd015&scoped=true"
import script from "./BackgroundRemoverDetail.vue?vue&type=script&lang=js"
export * from "./BackgroundRemoverDetail.vue?vue&type=script&lang=js"
import style0 from "./BackgroundRemoverDetail.vue?vue&type=style&index=0&id=020fd015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020fd015",
  null
  
)

export default component.exports